/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ShadowThresholdMode = {
    Conservative: 'conservative',
    Standard: 'standard',
    Permissive: 'permissive'
} as const;
export type ShadowThresholdMode = typeof ShadowThresholdMode[keyof typeof ShadowThresholdMode];


export function ShadowThresholdModeFromJSON(json: any): ShadowThresholdMode {
    return ShadowThresholdModeFromJSONTyped(json, false);
}

export function ShadowThresholdModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowThresholdMode {
    return json as ShadowThresholdMode;
}

export function ShadowThresholdModeToJSON(value?: ShadowThresholdMode | null): any {
    return value as any;
}

